import { z } from 'zod';

import { AiReviewSettingsResponseSchema } from '@/lib/ai-review-settings/schema';

export const AIReviewInstallationSettingsResponseSchema = z.object({
  persisted: z.boolean(),
  settings: AiReviewSettingsResponseSchema,
});

export type AIReviewInstallationSettingsResponse = z.infer<
  typeof AIReviewInstallationSettingsResponseSchema
>;
